module.exports = __webpack_public_path__ + "img/JA-centennial.29b2b102.png";